class AjaxPopup {
  constructor(options = {}) {
    this.template = options.template;
    this.selectors = options.selectors || {};
    this.classNames = options.classNames || {};
    this.parser = options.parser || null;
    this.onError = options.onError || (()=>{});
    this.bodyScroll = options.bodyScroll || {};
    this.visibleClass = this.classNames.visible || 'popup--visible';
    this.mediaQuery = this.bodyScroll.mediaQuery;

    this.popup = null;
    this.bindOpeners();
  }

  // Create DOM fragment from HTML string
  createFragment(html) {
    const tmpl = document.createElement('template');
    tmpl.innerHTML = html.trim();
    return tmpl.content.cloneNode(true);
  }

  // Bind click handlers to popup openers
  bindOpeners() {
    document.addEventListener('click', e => {
      const opener = e.target.closest("[data-popup]");
      if(!opener || e.ctrlKey || e.metaKey || e.button == 1){
        return;
      }
      e.preventDefault();
      const url = opener.getAttribute('href');
      const title = opener.dataset.popupTitle || '';
      const errorText = opener.dataset.errorText || '';
      if (url) this.load(url, title, errorText);
    });
  }

  // Fetch content and show popup
  async load(url, titleText, errorText) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('Request failed');
      const html = await res.text();
      const content = this.extractContent(html);
      if (!content) throw new Error('Content not found');
      this.showPopup(content, titleText);
    } catch (err) {
      this.onError?.(errorText);
    }
  }

  // Extract target element from HTML string
  extractContent(html) {
    if (!this.parser?.selector) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(this.parser.selector);
  }

  // Render and display popup
  showPopup(contentNode, titleText) {
    const fragment = this.createFragment(this.template);
    const popup = fragment.querySelector(this.selectors.parent);
    const close = popup.querySelector(this.selectors.closeButton);
    const slot = popup.querySelector(this.parser?.to);
    const title = popup.querySelector('.popup__title');

    if (!popup) return;

    popup.addEventListener('click', (e) => {
      if (e.target === popup) this.hidePopup();
    });

    if (close) close.addEventListener('click', () => this.hidePopup());

    if (slot && contentNode) {
      slot.innerHTML = '';
      slot.appendChild(contentNode);
    }

    if (title && titleText) {
      title.textContent = titleText;
    }

    popup.addEventListener('transitionend', () => {
      if (!popup.classList.contains(this.visibleClass)) {
        popup.remove();
        this.popup = null;
        document.body.style.overflow = '';
      }
    });

    document.body.appendChild(popup);
    this.popup = popup;

    if (this.mediaQuery?.matches) {
      document.body.style.overflow = 'hidden';
    }

    setTimeout(() => {
      popup.classList.add(this.visibleClass);
    }, 50);
  }

  // Hide popup
  hidePopup() {
    if (this.popup) {
      this.popup.classList.remove(this.visibleClass);
    }
  }
}

export default AjaxPopup;
